import styled from 'styled-components';

export const StyledEditorBar = styled.div`
  height: 100%;
  position: fixed;
  right: 0;
  top: 60px;
  width: 60px;
  z-index: 3000;
  align-items: center;
  background: ${props => props.theme.themeColors.controlBar.background};
  border-left: 1px solid
    ${({ theme }) => theme.themeColors.controlBar.borderBottomColor};
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.05);
  display: flex;
  justify-content: space-between;
  transition: background-color ${({ theme }) => theme.backgroundTransitionTime}
    ease;
  z-index: 2000;
`;